import React from 'react';
import Nav from './Nav';
import './header.css';

const Header = () => (
  <header>
    <h1>
      <a href="/">Daniel Rubio
        <span>
          Front-end Developer
        </span>
      </a>
    </h1>
    <Nav />
  </header>
);

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/Header.js